import {
	GetRefundProcedures,
	GetRefundProceduresModel,
	type GetRefundProceduresParams,
} from 'domain/usecases';

import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';

export class RemoteGetRefundProcedures implements GetRefundProcedures {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetRefundProceduresModel>,
	) {}

	async get({
		limit,
		page,
		signal,
	}: GetRefundProceduresParams): Promise<GetRefundProceduresModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params: {limit, page},
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
